import { render, staticRenderFns } from "./InfoItemsList.vue?vue&type=template&id=337c0951&"
import script from "./InfoItemsList.vue?vue&type=script&lang=js&"
export * from "./InfoItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports